import React from "react";
import {
  Body,
  GutterContainer,
  Spacer,
  LinkText
} from "@common/AggregationComponent";
import { useTranslation } from "react-i18next";
import { getEcRenewalCompatibility } from "@util/common";
import { useSelector } from "react-redux";
import { CombinedReducersType } from "@type/index";

const FilterNoResult = (props: any): any => {
  const { handleClearAll, filterCount } = props;
  const config = useSelector((store: CombinedReducersType) => store.app);

  const { t } = useTranslation();
  return (
    <GutterContainer className="fr-ec-mb-spacing-08">
      <Spacer element="div" variant="spacing-05" />
      <Body element="p" className="fr-ec-mb-spacing-04">
        {t("text_nosearchresult")}
      </Body>
      {filterCount && filterCount !== "" && filterCount > 0 ? (
        <LinkText
          element="button"
          onClick={handleClearAll}
          ecRenewal={getEcRenewalCompatibility()}
        >
          {t("text_image_search_clear_all_filters")}
        </LinkText>
      ) : (
        <div style={{ height: "24px" }} />
      )}
      {/* For fix filter modal scroll error: setting min height */}
      <div style={{ height: config.isApp ? "360px" : "260px" }} />
    </GutterContainer>
  );
};

export default FilterNoResult;
